import * as VO from "Data/VoiceOver";
import { ResourceType } from "./ResourceType";


export const templateResources: {
    [k in ResourceType]: { sprite: string; sprite_graph: string; hoverVO: string; };
} = {
    "aquaticplant": {
        sprite: "cyberchase-reststop-aquaticplant-stroke",
        sprite_graph: "cyberchase-reststop-aquaticplant-dropshadow",
        hoverVO: VO.REST_STOP_FOOD_POND_WEED,
    },
    "berries": {
        sprite: "cyberchase-reststop-berries-stroke",
        sprite_graph: "cyberchase-reststop-berries-dropshadow",
        hoverVO: VO.REST_STOP_FOOD_BERRIES,
    },
    "corn": {
        sprite: "cyberchase-reststop-corn-stroke",
        sprite_graph: "cyberchase-reststop-corn-dropshadow",
        hoverVO: VO.REST_STOP_FOOD_CORN,
    },
    "flower": {
        sprite: "cyberchase-reststop-flower-stroke",
        sprite_graph: "cyberchase-reststop-flower-dropshadow",
        hoverVO: VO.REST_STOP_FOOD_FLOWER,
    },
    "lilypad": {
        sprite: "cyberchase-reststop-lilypad-stroke",
        sprite_graph: "cyberchase-reststop-lilypad-dropshadow",
        hoverVO: VO.REST_STOP_FOOD_LILY,
    },
};
